import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, checked } = useAuth();

  if (!checked || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-paper" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-signal" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;

  return children;
};
